export default __webpack_public_path__ + "static/media/antiGlareIdentityCard.d2cb70ce.svg";